export const parsePrintingWayNamesFromQuery = (importsName) => {
  if (!importsName) return [];

  const names = Array.isArray(importsName) ? importsName : [importsName];

  return [
    ...new Set(
      names
        .flatMap((name) => String(name).split("/"))
        .map((name) => name.trim())
        .filter(Boolean)
    )
  ];
};

export const serializePrintingWayNamesToQuery = (names = []) => {
  if (!Array.isArray(names)) return "";

  return names
    .map((name) => String(name).trim())
    .filter(Boolean)
    .join("/");
};

export const normalizePrintingWayFacets = (facets = []) => {
  if (!Array.isArray(facets)) return [];

  return facets
    .map((item) => ({
      ...item,
      nameEn: item?.nameEn || "",
      count: Number(item?.count) || 0
    }))
    .filter((item) => item.nameEn);
};
